import type { AxiosPromise } from 'axios'
import Qs from 'qs'
import type { TreeNodeType } from '@user-center/utils/menu'
import request from '@user-center/utils/request'
import { getCurrentLocaleTransferCode, isToTransfer } from '@user-center/utils/i18n.ts'

export function login(data: {
  username: string
  password: string
  shopId: string | number
}): AxiosPromise<any> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  let isNw = window["require"] && window["nw"]
  let hardName=null;
  if(isNw){
    try{
      hardName=window.require('os').userInfo().username
    }catch(e){
      console.log(e);
    }
  }
  let uuid= window.localStorage.getItem('machineId')
  if (isSubAccount) {
    // 子账户登录
    return request({
      url: '/portal/subAuth/subUserlogin',
      method: 'post',
      data: Qs.stringify({
        ...data,
        hardName,
        hardCode:uuid
      }),
    })
  }
  
  
  return request({
    url: isNw?'/portal/auth/loginAndVerify':'/portal/auth/login',
    method: 'post',
    transformRequest: [
      function (data) {
        data = Qs.stringify(data)
        return data
      },
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data:{
      ...data,
      hardName,
      hardCode:uuid
    },
  })
}
export interface ResponeMenuData {
  data: TreeNodeType[]
}
export function getAllMenu(): Promise<ResponeMenuData> {
  return request({
    url: '/portal/menuList/getAll?transferlocate=true',
    method: 'post',
    data: {
      /*
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              // menu 节点本身
              ["data", "name"],
              // 下拉子菜单（兼容多层级）
              ["data", "children", "name"],
              ["data", "children", "children", "name"],
              ["data", "children", "children", "children", "name"],
              ["data", "children", "children", "children", "children", "name"],
            ]),
          }
        : undefined,
        */
    },
  }) as Promise<ResponeMenuData>
}

export function getRoleMenu(roleIds: string[]): Promise<ResponeMenuData> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    // 子账户角色菜单
    return request({
      url: '/portal/subRole/getRoleMenuList',
      method: 'post',
      data: {
        param: roleIds,
      },
    }) as Promise<ResponeMenuData>
  }
  return request({
    url: '/portal/role/getRoleMenuList?transferlocate=true',
    method: 'post',
    data: {
      param: roleIds,
      /*
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data", "name"],
              ["data", "children", "name"],
              ["data", "children", "children", "name"],
              ["data", "children", "children", "children", "name"],
              ["data", "children", "children", "children", "children", "name"],
            ]),
          }
        : undefined,
        */
    },
  }) as Promise<ResponeMenuData>
}

export function getInfo(username: string): Promise<unknown> {
  return request({
    url: '/portal/user/query',
    method: 'post',
    data: {
      param: {
        account: username,
      },
      //   optType: "QUERY"
    },
  })
    .then((res: any) => {
      let setInfo = res.data || {}
      if (res.data && res.data.dataList && res.data.dataList[0]) {
        res.data.dataList[0].name = res.data.dataList[0].realName
        setInfo = res.data.dataList[0]
      }
      return new Promise((resolve) => {
        // request({
        //   url: "/portal/organization/vaildTopOrganizationAccount",
        //   method: "post",
        //   data: {
        //     param: setInfo.id,
        //     //   optType: "QUERY"
        //   },
        // })
        //   .then((resData) => {
        //     resolve({ ...setInfo, isTopOrganization: !!resData.data });
        //   })
        //   .catch((err) => {
        //     console.log(err);
        //     resolve({ ...setInfo, isTopOrganization: false });
        //   });
        resolve({ ...setInfo, isTopOrganization: false })
      })
    })
    .then((userInfo) => {
      return { data: userInfo }
    })
}
export function getInfo_(): Promise<unknown> {
  const isSubAccount = localStorage.getItem('isSubAccount')
  if (isSubAccount) {
    // 子账户信息
    return request({
      url: '/portal/subUser/queryCurrentUser',
      method: 'post',
    }).then((res: any) => {
      let setInfo = res.data || {}
      if (res.data && res.data.dataList && res.data.dataList[0]) {
        res.data.dataList[0].name = res.data.dataList[0].realName
        setInfo = res.data.dataList[0]
      }
      return new Promise((resolve) => {
        resolve({ ...setInfo, isTopOrganization: false })
      })
    })
      .then((userInfo) => {
        return { data: userInfo }
      })
  }

  return request({
    url: '/portal/user/queryCurrentUser',
    method: 'post',
  })
    .then((res: any) => {
      let setInfo = res.data || {}
      if (res.data && res.data.dataList && res.data.dataList[0]) {
        res.data.dataList[0].name = res.data.dataList[0].realName
        setInfo = res.data.dataList[0]
      }
      return new Promise((resolve) => {
        resolve({ ...setInfo, isTopOrganization: false })
      })
    })
    .then((userInfo) => {
      return { data: userInfo }
    })
}

export function getFundInfo(userId: string): Promise<any> {
  // 账户查询
  return request({
    url: '/admin/fundInfo/queryByUserId',
    method: 'post',
    data: {
      param: {
        userId,
      },
    },
  }).then((res) => {
    return res
  })
}

export function queryCustomerInfo(userId: string): Promise<any> {
  // 账户查询
  return request({
    url: '/customerInfo/queryCustomerInfo',
    method: 'post',
    data: {
      userId,
    },
  }).then((res) => {
    return res
  })
}

export function sumCustomerWithholding(): Promise<any> {
  // 首页-预扣款
  return request({
    url: '/portal/billing/sumCustomerWithholding',
    method: 'post',
    data: {},
  }).then((res) => {
    return res
  })
}

export function logout(): AxiosPromise<unknown> {
  // return new Promise((resolve, reject) => {
  //   resolve(1);
  // });
  // 注销逻辑
  return request({
    url: '/portal/auth/logout',
    method: 'post',
    data: {},
  })
}

export function loginNoCheck(data: any): AxiosPromise<unknown> {
  // 直接登录
  return request({
    url: '/portal/auth/loginNoCheck',
    method: 'post',
    transformRequest: [
      function (data) {
        data = Qs.stringify(data)
        return data
      },
    ],
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data,
  })
}

// 子账户列表
export function subAccountList(data: any): Promise<any> {
  return request({
    url: '/portal/subUser/query',
    method: 'post',
    data,
  })
}

// 新增子账户
export function addSubAccount(data: any): Promise<any> {
  return request({
    url: '/portal/subUser/insert',
    method: 'post',
    data,
  })
}

// 修改子账户
export function updateSubAccount(data: any): Promise<any> {
  return request({
    url: '/portal/subUser/update',
    method: 'post',
    data,
  })
}

// 删除子账户
export function deleteSubAccount(data: any): Promise<any> {
  return request({
    url: '/portal/subUser/delete',
    method: 'post',
    data,
  })
}

// 子账号角色列表
export function subRoleList(data: any): Promise<any> {
  return request({
    url: '/portal/subRole/query',
    method: 'post',
    data,
  })
}

// 子账号角色新增
export function addSubRole(data: any): Promise<any> {
  return request({
    url: '/portal/subRole/insert',
    method: 'post',
    data,
  })
}

// 子账号角色修改
export function updateSubRole(data: any): Promise<any> {
  return request({
    url: '/portal/subRole/update',
    method: 'post',
    data,
  })
}

// 删除子账号角色
export function deleteSubRole(data: any): Promise<any> {
  return request({
    url: '/portal/subRole/delete',
    method: 'post',
    data,
  })
}

// 获取店铺菜单
export function getShopMenuList(data: any): Promise<any> {
  return request({
    url: '/portal/menuList/getShopMenuList',
    method: 'post',
    data: {
      ...(data || {}),
      ___transferConfig: isToTransfer()
        ? {
            language: getCurrentLocaleTransferCode(),
            transferKeysConfig: JSON.stringify([
              ["data", "name"],
              ["data", "children", "name"],
              ["data", "children", "children", "name"],
              ["data", "children", "children", "children", "name"],
              ["data", "children", "children", "children", "children", "name"],
            ]),
          }
        : undefined,
    },
  })
}

// 子账户店铺关联
export function queryUserSubAccountRelation(data: any): Promise<any> {
  data.param = {
    ...(data.param || {}),
    pageNo: 0,
    pageSize: 1000,
  }
  return request({
    url: '/portal/subUser/queryRelation',
    method: 'post',
    data,
  })
}

// ....
export function updateAssignMenu(data: any): Promise<any> {
  return request({
    url: '/portal/subRole/assignMenu',
    method: 'post',
    data,
  })
}

// 粉丝统计
export function getFansCount(data: any): Promise<any> {
  return request({
    url: '/portal/user/getFansCount?hiddenErrTip=1',
    method: 'post',
    data,
  })
}

// 粉丝列表
export function getFansList(data: any): Promise<any> {
  return request({
    url: '/portal/user/getFansList',
    method: 'post',
    data,
  })
}

// 提现到支付宝 银行卡
export function withdrawalApply(data: any): Promise<any> {
  return request({
    url: '/user/withdrawalManage/apply',
    method: 'post',
    data,
  })
}

// 提现到余额 
export function withdrawalApplyToBalance(data: any): Promise<any> {
  return request({
    url: '/user/withdrawalManage/applyToBalance',
    method: 'post',
    data,
  })
}
// 提现记录
export function withdrawalApplyRecord(data: any): Promise<any> {
  return request({
    url: '/user/withdrawalManage/applyRecord',
    method: 'post',
    data,
  })
}

// 保存用户提现信息
export function saveUserWithdrawal(data: any): Promise<any> {
  return request({
    url: '/portal/user/saveUserWithdrawal',
    method: 'post',
    data,
  })
}

// 更新用户提现信息
export function updateUserWithdrawal(data: any): Promise<any> {
  return request({
    url: '/portal/user/updateUserWithdrawal',
    method: 'post',
    data,
  })
}

// 分组列表
export function subGroupList(data: any): Promise<any> {
  return request({
    url: '/portal/subGroup/query',
    method: 'post',
    data,
  })
}

// 新增分组
export function addSubGroup(data: any): Promise<any> {
  return request({
    url: '/portal/subGroup/save',
    method: 'post',
    data,
  })
}

// 修改分组
export function updateSubGroup(data: any): Promise<any> {
  return request({
    url: '/portal/subGroup/update',
    method: 'post',
    data,
  })
}

// 删除分组
export function deleteSubGroup(data: any): Promise<any> {
  return request({
    url: '/portal/subGroup/delete',
    method: 'post',
    data,
  })
}
